import { Stack } from '../Stack';
import {
    DialogFooterElement,
    DialogFooterPrimaryStack,
    DialogFooterBaseStack as DialogFooterSecondaryStack,
} from './style';
import { DialogFooterProps } from './types';

export const DialogFooter = ({ primary, secondary, responsive = true }: DialogFooterProps) => (
    <DialogFooterElement>
        <Stack
            spacing="150"
            distribution="space-between"
            itemAlignment="center"
            largePhoneMax={{ vertical: responsive, distribution: 'space-between' }}
        >
            {secondary ? (
                <DialogFooterSecondaryStack
                    alignment="start"
                    largePhoneMax={{ vertical: responsive, spacing: '150' }}
                    responsive={responsive}
                >
                    {secondary}
                </DialogFooterSecondaryStack>
            ) : (
                <div />
            )}
            <DialogFooterPrimaryStack
                alignment="end"
                largePhoneMax={{ vertical: responsive, spacing: '150' }}
                responsive={responsive}
            >
                {primary}
            </DialogFooterPrimaryStack>
        </Stack>
    </DialogFooterElement>
);
